import { ApiEndpointBuilder } from "@/services/api/types";

const resendInvitationUserEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: ({ invitationId }) => ({
      url: `/invitations/${invitationId}/resend`,
      method: "PUT",
    }),
    invalidatesTags: ["usersInvitationsList"],
  });
};

type Request = {
  invitationId: string;
};

export default resendInvitationUserEndpoint;
